import React from 'react';
import styles from './styles.module.css';

export interface Props {
    isToggled: boolean;
    onToggle: () => void;
}

const Toggle: React.FC<Props> = ({ isToggled, onToggle }) => (
    <label className={styles.switch}>
        <input type="checkbox" checked={isToggled} onChange={onToggle} />
        <span className={styles.slider} />
    </label>
);

export default Toggle;
